import { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';

export const useTokenCheck = () => {
  const [tokenAvailable, setTokenAvailable] = useState(false);
  const { accounts, inProgress } = useMsal();

  useEffect(() => {
    // Check if user is authenticated via MSAL accounts
    // A user is considered authenticated if they have at least one account in MSAL
    const isAuthenticated = accounts && accounts.length > 0 && inProgress === 'none';
    setTokenAvailable(isAuthenticated);
  }, [accounts, inProgress]);

  return tokenAvailable;
};
